import React from 'react';
import Modal from 'mf-react-ui/Modal';
import Button from 'mf-react-ui/Button';
import SanitizeMessage from '../../components/SanitizeMessage/SanitizeMessage';
import { ImageSuccess } from '../../types';
import '../../style.scss';
import './SubscriptionApiModal.scss';

type Props = {
  isOpen: boolean;
  title: string;
  message: string;
  imageClass: ImageSuccess;
  note?: string;
  buttonFirst?: {
    text: string;
    url?: string;
    onClick?: () => void;
  };
  buttonSecond?: {
    text: string;
    url?: string;
    onClick?: () => void;
  };
  onClose?: () => void;
  hideModal: () => void;
};

const SubscriptionApiModal: React.FC<Props> = (props) => {
  const {
    isOpen,
    title,
    message,
    imageClass,
    note,
    buttonFirst,
    buttonSecond,
    onClose,
    hideModal,
  } = props;

  const handleFirstButtonClick = (): void => {
    if (buttonFirst && buttonFirst.onClick) {
      buttonFirst.onClick();
    }
  };

  const handleSecondButtonClick = (): void => {
    if (buttonSecond && buttonSecond.onClick) {
      buttonSecond.onClick();
    }
  };

  const handleCloseButtonClick = () => {
    if (onClose) {
      onClose();
    }

    hideModal();
  };

  return (
    <Modal
      className="modal_content-center modal_with-subscription-api"
      titleId="dialog-title"
      initialFocus=".modal__close"
      isOpen={isOpen}
      size="l"
      onCloseButtonClick={handleCloseButtonClick}
    >
      <div className="dialog-subscription">
        <div className={`dialog-subscription__img ${imageClass}`} />
        <h2 className="dialog-subscription__title">{title}</h2>
        <SanitizeMessage className="dialog-subscription__message" html={message} />
        {note && <SanitizeMessage className="dialog-subscription__note" html={note} />}
        {(buttonFirst || buttonSecond) && (
          <div className="dialog-subscription__actions">
            {buttonFirst && (
              <Button
                className="dialog-subscription__button"
                {...(buttonFirst.url && {
                  as: 'a',
                  target: '_blank',
                  rel: 'nofollow noopener noreferrer',
                  href: buttonFirst.url,
                })}
                onClick={handleFirstButtonClick}
              >
                {buttonFirst.text}
              </Button>
            )}
            {buttonSecond && (
              <Button
                className="dialog-subscription__button"
                view="transparentDark"
                {...(buttonSecond.url && {
                  as: 'a',
                  target: '_blank',
                  rel: 'nofollow noopener noreferrer',
                  href: buttonSecond.url,
                })}
                onClick={handleSecondButtonClick}
              >
                {buttonSecond.text}
              </Button>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SubscriptionApiModal;
